import styled from "styled-components";

export const OnlineFormRequestEditItemWidgetStyled = styled.div`
  .question_label {
  }
  .question_value {
    color: ${({ theme }) => theme.COLORS.BLACK_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S15};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    span {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
  }
  .reject_label {
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    span {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
  }
  .form_wrap {
    margin-top: 20px;
    width: 100%;
  }
  .online_form_action_block {
    display: flex;
    justify-content: flex-end;
    .btn_req_edit_wrap {
      margin-top: 20px;
    }
  }
`;
